import { IText, translate } from './translator';

export class TranslateValueConverter  {
	toView(value: object, params: any) {
		return value != null && typeof(value) === 'object'
			? translate(value as IText)
			: value;
	}
}
